import React from "react";
import Modal from "../../../../../../../../../components/Modal/Modal";
import VerbaFloLogoWithAlertIcon from "../../../../../../../../../assets/svg/verbaflo-logo-with-alert-icon";
import CloseIcon from "../../../../../../../../../assets/svg/close-icon";
import Button from "../../../../../../../../../components/Button/Button";

const DueDateAlertModal = ({
  open,
  onOpenChange,
  onSubmit,
  isLoading,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onSubmit: () => void;
  isLoading?: boolean;
}) => {
  return (
    <Modal
      open={open}
      onOpenChange={onOpenChange}
      headerClassName="flex items-center justify-end"
      contentClassName="max-h-[90vh] bg-pure-white dark:bg-pure-white-dk"
      bodyClassName="!px-6 !py-[18px] w-[450px] "
      showCloseButton={false}
    >
      <div className="flex flex-col items-center gap-3">
        <div className="flex w-full items-start justify-between gap-2">
          <div className="flex gap-2">
            <VerbaFloLogoWithAlertIcon className="w-6 h-6" />
          </div>
          <span className="text-base font-medium text-heading-text dark:text-heading-text-dk">
            Delivery time will be recalculated
          </span>
          <button
            className="w-[15px] h-[15px] ml-auto self-start bg-gray-100 dark:bg-tag-gray-dk rounded-full flex flex-col items-center justify-center transition-transform duration-200 hover:scale-110"
            onClick={() => onOpenChange(false)}
          >
            <CloseIcon className="w-[5.5px] h-[5.5px] text-verba-indigo dark:text-verba-indigo-dk" />
          </button>
        </div>
        <span className="text-md text-data dark:text-data-dk">
          Because priority was updated after scheduling began,the estimated
          delivery date will be recalculated based on when this change was made.
          Your original timeline will no longer apply.
        </span>
        <div className="flex justify-end items-center gap-2 w-full mt-3">
          <Button
            innerText="Okay, got it"
            buttonContainerClass="w-[110px] py-[4px] border border-verba-indigo dark:border-verba-indigo-dk hover:bg-hover-effect dark:hover:bg-hover-effect-dk rounded-[8px]"
            innerTextClass="text-heading-text dark:text-heading-text-dk text-md font-semibold"
            onClick={onSubmit}
            isLoading={isLoading}
          />
        </div>
      </div>
    </Modal>
  );
};

export default DueDateAlertModal;
